import React from 'react';
import { Link } from 'react-router-dom';
import './Css/BothButtons.css';

function Button({ btnLink, btnName }) {
  return (
    <button className="transparent-btn">
      <Link to={btnLink}>{btnName}</Link>
    </button>
  );
}

export default Button;
